import { render, staticRenderFns } from "./SplitLayout.vue?vue&type=template&id=3d8a2487&scoped=true"
import script from "./SplitLayout.vue?vue&type=script&lang=ts"
export * from "./SplitLayout.vue?vue&type=script&lang=ts"
import style0 from "./SplitLayout.vue?vue&type=style&index=0&id=3d8a2487&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8a2487",
  null
  
)

export default component.exports